// extracted by mini-css-extract-plugin
export default {"orgPackUpDiv":"orgGuidPackUpload_orgPackUpDiv__K+t+G"};